import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { useContext as no, useState as z, useRef as E, Fragment as ao } from "react";
import { useTranslation as io } from "react-i18next";
import u from "classnames";
import { useSensors as ro, useSensor as so, PointerSensor as co, DndContext as bo, DragOverlay as po } from "@dnd-kit/core";
import { SortableContext as uo, rectSortingStrategy as mo } from "@dnd-kit/sortable";
import "../../../components/Breadcrumbs/index.js";
import w from "../../../components/Button/index.js";
import "reactjs-popup";
import fo from "../../../icons/Plus.js";
import _o from "../../../icons/Trash.js";
import { ThemeContext as ho } from "../../../components/ThemeContext/index.js";
import yo from "../../../components/Modal/index.js";
import "../../../fields/Input/index.js";
import "../../../components/Tooltip/index.js";
import vo from "../../../components/RemoveModal/index.js";
import L from "../../../data/mock.js";
import { HeaderRemove as Co, HeaderRow as go, ProductsRow as U, ProductsTotalRow as q } from "./FillProductsTableRows/index.js";
import G from "./FillProductsTableButtons/index.js";
import So from "./useTableRowHover.js";
import To from "./useRowsDnd.js";
const Bo = "forma-ui__fill-products-table__tableWrapper", wo = "forma-ui__fill-products-table__table", Mo = "forma-ui__fill-products-table__buttons", No = "forma-ui__fill-products-table__buttonAdd", Ao = "forma-ui__fill-products-table__toolbar", Ro = "forma-ui__fill-products-table__toolbarButtons", xo = "forma-ui__fill-products-table__toolbarButton", ko = "forma-ui__fill-products-table__toolbarMobile", Io = "forma-ui__fill-products-table__toolbarButtonsMobile", Oo = "forma-ui__fill-products-table__toolbarButtonMobile", Do = "forma-ui__fill-products-table__toolbarButtonMobileIcon", Wo = "forma-ui__fill-products-table__small", e = {
  tableWrapper: Bo,
  table: wo,
  buttons: Mo,
  buttonAdd: No,
  toolbar: Ao,
  toolbarButtons: Ro,
  toolbarButton: xo,
  toolbarMobile: ko,
  toolbarButtonsMobile: Io,
  toolbarButtonMobile: Oo,
  toolbarButtonMobileIcon: Do,
  small: Wo
}, Fo = 120, J = {
  id: "name",
  name: "",
  canApplyToAll: !1,
  isSimilar: !1
}, nt = ({
  products: n,
  productsTotal: h,
  columns: s,
  total: K,
  customProductsIds: M,
  actions: P,
  changes: Q
}) => {
  const { t: m } = io(), { viewport: V } = no(ho), i = V === "phone", { onClickAdd: N, onClickAddManual: A, onClickImport: R, onClickAddSection: x } = P, { onApplyToAll: k, onChangeCell: I, onChangeTotalCell: O, onRemove: D, onSort: X } = Q, [y, v] = z(null), [C, f] = z(null), W = n.map(({ id: o }) => o), { moveId: c, dndEvents: Y } = To({
    ids: W,
    onRemove: D,
    onSort: X
  }), b = n.find(({ id: o }) => o === c), F = E(null), g = E(null), { hoverId: d } = So({ tableRef: F, toolbarRef: g, disabled: !!c, on: i ? "focus" : "hover" }), H = n.findIndex(({ id: o }) => o === d), Z = ro(
    so(co, {
      activationConstraint: {
        distance: 3
      }
    })
  ), S = s.map((o) => {
    const l = L.productTableColumns.find(({ id: B }) => B === o.id), a = !(l != null && l.readOnly) && n.length && n[0][o.id], p = a || a === 0 ? n.every((B) => B[o.id] === a) : !1;
    return {
      ...o,
      type: (l == null ? void 0 : l.type) || o.type,
      readOnly: (l == null ? void 0 : l.readOnly) || o.readOnly || !1,
      canApplyToAll: (l == null ? void 0 : l.canApplyToAll) || o.canApplyToAll || !1,
      isSimilar: p
    };
  }), T = K.map((o) => {
    const l = L.productTableFooter.find(({ id: a }) => a === o.id);
    return {
      ...o,
      readOnly: (l == null ? void 0 : l.readOnly) || o.readOnly || !1,
      type: (l == null ? void 0 : l.type) || o.type
    };
  }), _ = !!Object.keys(h).length && !!T.length, $ = !i && _ && s.length === 1 ? 2 : void 0, j = !i && _ && s.length === 1 ? 2 : void 0, oo = !i, to = i, lo = !i && _, eo = i && _;
  return /* @__PURE__ */ r(bo, { sensors: Z, ...Y, children: [
    /* @__PURE__ */ r("div", { className: e.root, children: [
      /* @__PURE__ */ r("div", { className: u(e.tableWrapper, "styled-scrollbar"), children: [
        /* @__PURE__ */ t(Co, {}),
        /* @__PURE__ */ r(
          "table",
          {
            className: u(e.table, "fill-products-table"),
            cellPadding: 0,
            cellSpacing: 0,
            style: { minWidth: s.length * Fo },
            ref: F,
            children: [
              /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ t(
                go,
                {
                  columns: s,
                  colSpan: $
                }
              ) }),
              /* @__PURE__ */ r("tbody", { children: [
                n && /* @__PURE__ */ t(uo, { items: W, strategy: mo, children: n.map((o) => /* @__PURE__ */ r(ao, { children: [
                  /* @__PURE__ */ t(
                    U,
                    {
                      id: o.id,
                      item: o,
                      columns: o.type === "title" ? [J] : S,
                      isCustom: M.includes(o.id),
                      onApplyToAll: k,
                      onChangeCell: I,
                      colSpan: j ?? (o.colspan ? Number(o.colspan) : void 0)
                    },
                    o.id
                  ),
                  to && d === o.id && /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t("td", { colSpan: S.length + 1, className: e.toolbarMobile, children: /* @__PURE__ */ r(
                    "div",
                    {
                      className: e.toolbarButtonsMobile,
                      ref: g,
                      children: [
                        /* @__PURE__ */ t(
                          w,
                          {
                            viewStyle: "primary",
                            size: "extraSmall",
                            className: e.toolbarButtonMobile,
                            iconClassName: e.toolbarButtonMobileIcon,
                            icon: /* @__PURE__ */ t(fo, {}),
                            onClick: () => f({ id: d, index: H }),
                            children: m("uikit:add")
                          }
                        ),
                        /* @__PURE__ */ t(
                          w,
                          {
                            viewStyle: "secondary",
                            size: "extraSmall",
                            className: e.toolbarButtonMobile,
                            iconClassName: e.toolbarButtonMobileIcon,
                            icon: /* @__PURE__ */ t(_o, {}),
                            onClick: () => v(d),
                            children: m("uikit:delete")
                          }
                        )
                      ]
                    }
                  ) }) })
                ] }, o.id)) }),
                lo && T.map(({ id: o, name: l, readOnly: a, type: p }) => /* @__PURE__ */ t(
                  q,
                  {
                    id: o,
                    name: l,
                    type: p,
                    productsTotal: h,
                    readOnly: a,
                    colSpan: s.length - 1,
                    onChangeTotal: O
                  },
                  o
                ))
              ] })
            ]
          }
        ),
        oo && /* @__PURE__ */ t(
          "div",
          {
            className: u(e.toolbar, "fill-products-table-row-toolbar"),
            ref: g,
            children: d && /* @__PURE__ */ t(
              G,
              {
                index: H,
                onClickAdd: N,
                onClickImport: R,
                onClickAddSection: x,
                onClickAddManual: A,
                onClickRemove: () => v(d),
                className: e.toolbarButtons,
                buttonsClassName: e.toolbarButton,
                showTextShort: !0
              }
            )
          }
        )
      ] }),
      i && /* @__PURE__ */ t("div", { className: e.buttons, children: /* @__PURE__ */ t(
        w,
        {
          viewStyle: "primary",
          size: "extraSmall",
          onClick: () => f({ id: n[n.length - 1].id, index: n.length - 1 }),
          children: m("uikit:add_product_service")
        }
      ) }),
      eo && /* @__PURE__ */ t("div", { className: u(e.tableWrapper, "styled-scrollbar"), children: /* @__PURE__ */ t("table", { className: u(e.table, e.small), cellPadding: 0, cellSpacing: 0, children: /* @__PURE__ */ t("tbody", { children: T.map(({ id: o, name: l, readOnly: a, type: p }) => /* @__PURE__ */ t(
        q,
        {
          id: o,
          name: l,
          type: p,
          productsTotal: h,
          readOnly: a,
          onChangeTotal: O
        },
        o
      )) }) }) })
    ] }),
    /* @__PURE__ */ t(po, { children: c && b && /* @__PURE__ */ t("table", { className: e.table, cellPadding: 0, cellSpacing: 0, children: /* @__PURE__ */ t("tbody", { children: /* @__PURE__ */ t(
      U,
      {
        id: c,
        item: b,
        columns: b.type === "title" ? [J] : S,
        isCustom: M.includes(c),
        onApplyToAll: k,
        onChangeCell: I,
        colSpan: j ?? (b.colspan ? Number(b.colspan) : void 0)
      }
    ) }) }) }),
    /* @__PURE__ */ t(
      vo,
      {
        open: !!y,
        onClose: () => v(null),
        onRemove: () => {
          y && setTimeout(() => D(y));
        },
        title: m("uikit:deleting_row")
      }
    ),
    /* @__PURE__ */ t(
      yo,
      {
        open: !!C,
        onClose: () => f(null),
        children: C && /* @__PURE__ */ t(
          G,
          {
            index: C.index,
            onClickAdd: N,
            onClickImport: R,
            onClickAddSection: x,
            onClickAddManual: A,
            onClickAny: () => f(null),
            showDescription: !0
          }
        )
      }
    )
  ] });
};
export {
  nt as default
};
